var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/goals") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3.515625e-05 0 45 0 45 47.9999652 3.515625e-05 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-217.000000, -681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/goals",
    transform: "translate(217.000000, 681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,47.9999652 L22.5000352,47.9999652 C10.073707,47.9999652 3.515625e-05,38.0333565 3.515625e-05,25.7390957 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,25.7390957 C45.0000352,38.0333565 34.9263633,47.9999652 22.5000352,47.9999652",
    id: "Fill-1",
    fill: "#AF825D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,44.5217043 L22.5000352,44.5217043 C10.073707,44.5217043 3.515625e-05,34.5550957 3.515625e-05,22.2608348 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,22.2608348 C45.0000352,34.5550957 34.9263633,44.5217043 22.5000352,44.5217043",
    id: "Fill-4",
    fill: "#E5B389",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7812852,-3.47826087e-05 L4.21878516,-3.47826087e-05 C1.88898047,-3.47826087e-05 3.515625e-05,1.86883478 3.515625e-05,4.17387826 L3.515625e-05,22.2608348 C3.515625e-05,34.5550957 10.0733555,44.5217043 22.5000352,44.5217043 L22.5000352,44.5217043 C34.9263633,44.5217043 45.0000352,34.5550957 45.0000352,22.2608348 L45.0000352,4.17387826 C45.0000352,1.86883478 43.1110898,-3.47826087e-05 40.7812852,-3.47826087e-05 M40.7812852,4.17387826 L40.7812852,22.2608348 C40.7812852,32.2340522 32.5803867,40.3477913 22.5000352,40.3477913 C12.4196836,40.3477913 4.21878516,32.2340522 4.21878516,22.2608348 L4.21878516,4.17387826 L40.7812852,4.17387826",
    id: "Fill-7",
    fill: "#CF9C6D",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    stroke: "#AF825D",
    strokeWidth: 4.17391304,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "32.2809609 14.937287 20.2888125 26.8019826 14.1252188 20.7038957"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.068ab39b1d1436b6965707bd7befc8df.svg";
export { ForwardRef as ReactComponent };